import { render, staticRenderFns } from "./TouchNumberHost.vue?vue&type=template&id=70cfe20a&"
import script from "./TouchNumberHost.vue?vue&type=script&lang=js&"
export * from "./TouchNumberHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports